var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:round-arrow-right-alt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.32536 8.66629L12.6654 8.66629C13.032 8.66629 13.332 8.36629 13.332 7.99962C13.332 7.63296 13.032 7.33296 12.6654 7.33296L5.32536 7.33296L5.32536 6.13962C5.32536 5.83962 4.96536 5.69296 4.7587 5.90629L2.90536 7.76629C2.7787 7.89962 2.7787 8.10629 2.90536 8.23962L4.7587 10.0996C4.96536 10.313 5.32536 10.1596 5.32536 9.86629L5.32536 8.66629Z",
    fill: "#5B5B5B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.af74749e750bbfc401be82cd1137ecab.svg";
export { ForwardRef as ReactComponent };